import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, NgForm} from "@angular/forms";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {HiperioCredentialsJob} from "../../../shared/interface/hiperio-credentials-job";
import {interval, ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../../../shared/services/auth.service";
import {FilterService} from "../../../shared/services/filter.service";
import {ActivatedRoute, Router} from "@angular/router";
import {select, Store} from "@ngrx/store";
import {StoreRootState} from "../../../shared/ngrx/reducers";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {ReceivablesImportsService} from "../../../shared/services/receivables-imports.service";
import {delay, distinctUntilChanged, takeUntil, tap} from "rxjs/operators";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";
import {getCurrentRouteState} from "../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../shared/ngrx/route-serializer";
import {HiperioTestAccessFormService} from "../../../shared/services/hiperio-test-access-form.service";
import {
  DictService,
  HIPERIO_TEST_ACCESS_FORM_STATUS,
  HIPERIO_TEST_ACCESS_FORM_STATUS_ACCEPTED, HIPERIO_TEST_ACCESS_FORM_STATUS_PENDING,
  HIPERIO_TEST_ACCESS_FORM_STATUS_REJECTION,
  PERSONAL_DATA_CHANGE_STATUS,
  PERSONAL_DATA_CHANGE_STATUS_COMPLETED
} from "../../../shared/services/dict.service";
import {Dictionary} from "../../../shared/interface/dictionary";
import {HttpErrorResponse} from "@angular/common/http";
import {el} from "@fullcalendar/core/internal-common";

@Component({
  selector: 'app-hiperio-test-access-form-list',
  templateUrl: './hiperio-test-access-form-list.component.html',
  styleUrls: ['./hiperio-test-access-form-list.component.scss']
})
export class HiperioTestAccessFormListComponent implements AfterViewInit, OnInit, OnDestroy  {
@ViewChild('filtersForm') filtersForm: NgForm;
@ViewChild(MatPaginator) paginator: MatPaginator;


  initialFilters: any;
  jobs: HiperioCredentialsJob[] = [];
  displayedColumns: string[] = ['ofwca' , 'createdAt', 'createdBy', 'status', 'action'];
  totalData = 0;
  userPermissions: ReplaySubject<UserPermissions>;
  actionForm: FormGroup;
  readonly HIPERIO_TEST_ACCESS_FORM_STATUS_ACCEPTED = HIPERIO_TEST_ACCESS_FORM_STATUS_ACCEPTED;
  readonly HIPERIO_TEST_ACCESS_FORM_STATUS_REJECTION = HIPERIO_TEST_ACCESS_FORM_STATUS_REJECTION;
  readonly HIPERIO_TEST_ACCESS_FORM_STATUS_PENDING = HIPERIO_TEST_ACCESS_FORM_STATUS_PENDING;


private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


  constructor(
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private auth: AuthService,
    private filterService: FilterService,
    private activatedRoute: ActivatedRoute,
    private store: Store<StoreRootState>,
    private router: Router,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private hiperioTestAccessFormService: HiperioTestAccessFormService,
    private receivablesImportService: ReceivablesImportsService,
    private dictService: DictService,
) {
    this.userPermissions = auth.getUserPermissions();
    this.hiperioTestAccessFormService.formListSubject
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<HiperioCredentialsJob>) => {
          this.jobs = e.items;
          this.totalData = e.pagination.total;
        })
      ).subscribe();
    this.parseFilters();
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      gte$createdAt: 'date',
      lte$createdAt: 'date',
      partner: 'string',
      ofwca: 'string',
      status: 'int',
      assetsRegional: 'string',
    }, filters);
  }

  ngOnInit(): void {

}

  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
        this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
          page: event.pageIndex,
          pageSize: event.pageSize,
          ...this.filtersForm.value
        })]);
      });

    this.store
      .pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
        takeUntil(this.destroyed$),
      )
      .subscribe((state: RouterStateUrl) => {
        this.parseFilters(state.params);
        this.paginator.pageIndex = state.params.page;
        this.paginator.pageSize = state.params.pageSize;

        this.loadListData();
      })
    ;
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  buildFilters(): any {
    const filters = {...this.initialFilters};

    return filters;
  }

  loadListData(): void {
    this.hiperioTestAccessFormService.loadList(this.paginator.pageIndex, this.paginator.pageSize, this.buildFilters());
  }

  filter(): void {
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      page: 0,
      pageSize: this.paginator.pageSize,
      ...this.filtersForm.value,
    })]);
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
      page: 0,
      pageSize: this.paginator.pageSize,
    }]);
  }

  changeStatus(id: string, status: string): void {
    this.dictService.get(status, HIPERIO_TEST_ACCESS_FORM_STATUS)
      .subscribe((dict: Dictionary) => {

        this.hiperioTestAccessFormService.updateStatus(id, dict.id)
          .subscribe(() => {
            this.loadListData();
            this.snack.open('Pomyślnie zmieniono status', '', {
              duration: 2000,
            });
          }, (error: HttpErrorResponse) => {
            this.snack.open('Podczas zmiany statusu wystąpił błąd', error.status.toString(), {
              duration: 2000,
            });
          });
      });
  }
}
